import { connect } from "react-redux";
import { getCatalogServicesSubCategoryRequest } from "store/actions/cos.actions";
import { getSPWorkerRequest } from "store/actions/sp.actions";
import { incidentActions } from "store/sagas/incident.sagas";
import { getCatalogSubCategoryStatesLoading } from "store/selector/cos.selector";
import { getStateOptions } from "store/selector/general.selector";
import {
  getAssignedParticipants,
  getAssignedParticipantsLoading,
  getCreatedIncident,
  getIncidentCreateLoading,
  getIncidentCreateSuccess,
  getIncidentUpdateLoading,
  getIncidentUpdateSuccess,
  getUpdatedIncident,
} from "store/selector/incident.selector";
import { getSpWorkers, getSpSetting } from "store/selector/sp.selector";
import { CreateIncidentContainer } from "./CreateIncidentContainer";

const mapStateToProps = (state) => ({
  createLoading: getIncidentCreateLoading(state),
  createSuccess: getIncidentCreateSuccess(state),
  createdIncident: getCreatedIncident(state),
  updateLoading: getIncidentUpdateLoading(state),
  updateSuccess: getIncidentUpdateSuccess(state),
  updatedIncident: getUpdatedIncident(state),
  assignedParticipants: getAssignedParticipants(state),
  assignedParticipantsLoading: getAssignedParticipantsLoading(state),
  workersList: getSpWorkers(state),
  catalogSubCategoryStatesLoading: getCatalogSubCategoryStatesLoading(state),
  stateOptions: getStateOptions(state),
  settings: getSpSetting(state),
});

const mapDispatchToProps = {
  createIncidentCall: incidentActions.createIncidentRequest,
  updateIncidentCall: incidentActions.updateIncidentRequest,
  resetCreateCall: incidentActions.resetIncidentCreate,
  getAssignedParticipantsCall: incidentActions.getAssignedParticipantsRequest,
  getWorkerListCall: getSPWorkerRequest,
  getCatalogServicesSubCategoryRequest,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateIncidentContainer);
